module.exports = __webpack_public_path__ + "static/media/1 27 hardt.6e09e6e9.mp3";